(function() {

	var Application = include("springroll.Application"),
		Sprite = include("PIXI.Sprite"),
		Texture = include("PIXI.Texture");

	var SuspectClue = function(state, id)
	{
		this.state = state;
		
		var normalTexture = this.normalTexture = Texture.fromFrame("suspect_clue_" + id);
		this.highlightTexture = Texture.fromFrame("suspect_clue_" + id + "_highlight");
		Sprite.call(this, this.normalTexture);
		
		this.id = id;
		var bottomOffset = Application.instance.config.game.suspect.clueBottomOffset;
		this.pivot.x = normalTexture.width / 2;
		this.pivot.y = normalTexture.height - bottomOffset;
		
		this.highlight = this.highlight.bind(this);
		this.unhighlight = this.unhighlight.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onMouseOver = this.onMouseOver.bind(this);
	};

	// Extend MovieClip
	var s = Sprite.prototype;
	var p = SuspectClue.prototype = Object.create(s);

	p.enable = function()
	{
		this.interactive = this.buttonMode = true;
		
		this.on("mouseover", this.onMouseOver);
		this.on("click", this.onClick);
		this.on("tap", this.onClick);
	};
	
	p.disable = function()
	{
		this.interactive = this.buttonMode = false;
		
		this.off("mouseover", this.onMouseOver);
		this.off("click", this.onClick);
		this.off("tap", this.onClick);
	};
	
	p.highlight = function()
	{
		this.texture = this.highlightTexture;
	};
	
	p.unhighlight = function()
	{
		this.texture = this.normalTexture;
	};
	
	p.onMouseOver = function()
	{
		this.state.clueHovers++;
	};
	
	p.onClick = function()
	{
		this.state.clueClicks++;
		this.state.playVO("Elmo_" + this.id + "End");
	};

	p.destroy = function()
	{
		s.destroy.call(this);
		this.state = this.normalTexture = this.highlightTexture = this.highlight =
			this.unhighlight = this.onClick = this.onMouseOver = null;
	};

	namespace('heist').SuspectClue = SuspectClue;
}());